"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RelayCallStatusCodes = exports.erc165Interfaces = exports.constants = void 0;
const bn_js_1 = __importDefault(require("bn.js"));
const IPaymaster_json_1 = __importDefault(require("./interfaces/IPaymaster.json"));
const IRelayHub_json_1 = __importDefault(require("./interfaces/IRelayHub.json"));
const IForwarder_json_1 = __importDefault(require("./interfaces/IForwarder.json"));
const IStakeManager_json_1 = __importDefault(require("./interfaces/IStakeManager.json"));
const IPenalizer_json_1 = __importDefault(require("./interfaces/IPenalizer.json"));
const IRelayRegistrar_json_1 = __importDefault(require("./interfaces/IRelayRegistrar.json"));
const Utils_1 = require("./Utils");
const Web3JSUtils_1 = require("./web3js/Web3JSUtils");
const dayInSec = 24 * 60 * 60;
const weekInSec = dayInSec * 7;
const yearInSec = dayInSec * 365;
const oneEther = (0, Web3JSUtils_1.toBN)(1e18);
exports.constants = {
    dayInSec,
    weekInSec,
    yearInSec,
    oneEther,
    ZERO_ADDRESS: '0x0000000000000000000000000000000000000000',
    // OpenZeppelin's ERC-20 implementation bans transfer to zero address
    BURN_ADDRESS: '0xFFfFfFffFFfffFFfFFfFFFFFffFFFffffFfFFFfF',
    // in order to avoid error on insufficient balance for gas, send dry-run call from zero address
    DRY_RUN_ADDRESS: '0x0000000000000000000000000000000000000000',
    DRY_RUN_KEY: 'DRY-RUN',
    ZERO_BYTES32: '0x0000000000000000000000000000000000000000000000000000000000000000',
    MAX_UINT256: new bn_js_1.default('2').pow(new bn_js_1.default('256')).sub(new bn_js_1.default('1')),
    MAX_UINT96: new bn_js_1.default('2').pow(new bn_js_1.default('96')).sub(new bn_js_1.default('1')),
    MAX_INT256: new bn_js_1.default('2').pow(new bn_js_1.default('255')).sub(new bn_js_1.default('1')),
    MIN_INT256: new bn_js_1.default('2').pow(new bn_js_1.default('255')).mul(new bn_js_1.default('-1')),
    ARBITRUM_ARBSYS: '0x0000000000000000000000000000000000000064'
};
exports.erc165Interfaces = {
    forwarder: (0, Utils_1.getERC165InterfaceID)(IForwarder_json_1.default),
    paymaster: (0, Utils_1.getERC165InterfaceID)(IPaymaster_json_1.default),
    penalizer: (0, Utils_1.getERC165InterfaceID)(IPenalizer_json_1.default),
    relayRegistrar: (0, Utils_1.getERC165InterfaceID)(IRelayRegistrar_json_1.default),
    relayHub: (0, Utils_1.getERC165InterfaceID)(IRelayHub_json_1.default),
    stakeManager: (0, Utils_1.getERC165InterfaceID)(IStakeManager_json_1.default)
};
exports.RelayCallStatusCodes = {
    OK: new bn_js_1.default('0'),
    RelayedCallFailed: new bn_js_1.default('1'),
    RejectedByPreRelayed: new bn_js_1.default('2'),
    RejectedByForwarder: new bn_js_1.default('3'),
    RejectedByRecipientRevert: new bn_js_1.default('4'),
    PostRelayedFailed: new bn_js_1.default('5'),
    PaymasterBalanceChanged: new bn_js_1.default('6')
};
//# sourceMappingURL=Constants.js.map